import request from '@/utils/request'

export function getSetting(data) {
	return request({
		url: '/public/getSetting',
		method: 'get',
		params: data
	})
}

// 获取充值金额列表
export function getRechargePackages() {
	return request({
		url: '/public/rechargePackages',
		method: 'get'
	})
}

// 消息通知列表
export function pageBusNotification(params) {
	return request({
		url: '/public/pageBusNotification',
		method: 'get',
		params
	})
}

// 消息通知详情
export function getBusNotificationInfo(busNotificationId) {
	return request({
		url: '/public/busNotification/info',
		method: 'get',
		params: { busNotificationId }
	})
}